// extracted by mini-css-extract-plugin
export var statItem = "_jm-1";
export var statsRow = "_jm-0";